import { Typography, Box, Container, Paper } from '@mui/material'

const PrivacyPage = () => {
  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: '#f5f5f5',
        padding: 2,
        overflow: 'auto',
      }}
    >
      <Container maxWidth="md">
        <Paper
          elevation={3}
          sx={{
            padding: 4,
            mt: 2,
            mb: 2,
          }}
        >
          <Typography 
            variant="h4" 
            component="h1" 
            gutterBottom 
            sx={{ 
              mb: 3, 
              fontWeight: 700,
              fontSize: '32px',
              color: '#000000',
              fontFamily: 'Arial, sans-serif'
            }}
          >
            TERMS AND CONDITIONS
          </Typography>
          
          <Box sx={{ color: '#000000', lineHeight: 1.6, fontFamily: 'Arial, sans-serif' }}>
          <Typography 
            variant="body1" 
            sx={{ 
              mb: 3,
              fontSize: '16px',
              color: '#000000',
              fontWeight: 400,
              marginBottom: '16px'
            }}
          >
            <strong>Last Updated: January 21, 2026</strong>
          </Typography>

          <Typography 
            variant="h6" 
            component="h2" 
            gutterBottom 
            sx={{ 
              mt: 3, 
              mb: 1.5, 
              fontWeight: 700,
              fontSize: '18px',
              color: '#000000'
            }}
          >
            1. Definitions
          </Typography>
          
          <Typography 
            variant="body1" 
            sx={{
              fontSize: '16px',
              color: '#000000',
              fontWeight: 400,
              marginBottom: 0,
              marginTop: 0
            }}
          >
            &quot;Company,&quot; &quot;We,&quot; &quot;Us,&quot; or &quot;Our&quot; refers to Transpots Inc., a corporation incorporated in Canada.
          </Typography>
          
          <Typography 
            variant="body1" 
            sx={{
              fontSize: '16px',
              color: '#000000',
              fontWeight: 400,
              marginBottom: 0,
              marginTop: 0
            }}
          >
            &quot;App&quot; refers to the Transpots mobile and web applications.
          </Typography>
          
          <Typography 
            variant="body1" 
            sx={{
              fontSize: '16px',
              color: '#000000',
              fontWeight: 400,
              marginBottom: 0,
              marginTop: 0
            }}
          >
            &quot;User,&quot; &quot;You,&quot; or &quot;Your&quot; refers to any individual or entity accessing or using the App.
          </Typography>

          <Typography 
            variant="h6" 
            component="h2" 
            gutterBottom 
            sx={{ 
              mt: 3, 
              mb: 1.5, 
              fontWeight: 700,
              fontSize: '18px',
              color: '#000000'
            }}
          >
            2. Acceptance of Terms
          </Typography>
          
          <Typography 
            variant="body1" 
            sx={{
              fontSize: '16px',
              color: '#000000',
              fontWeight: 400,
              marginBottom: 0,
              marginTop: 0
            }}
          >
            By accessing or using the App, you agree to be bound by these Terms and Conditions and our Privacy Policy.
          </Typography>
          
          <Typography 
            variant="body1" 
            sx={{
              fontSize: '16px',
              color: '#000000',
              fontWeight: 400,
              marginBottom: 0,
              marginTop: 0
            }}
          >
            If you do not agree, you must immediately discontinue use of the App.
          </Typography>
          
          <Typography 
            variant="body1" 
            sx={{
              fontSize: '16px',
              color: '#000000',
              fontWeight: 400,
              marginBottom: 0,
              marginTop: 0
            }}
          >
            We may update these Terms from time to time. Continued use of the App after updates constitutes acceptance of the revised Terms.
          </Typography>

          <Typography 
            variant="h6" 
            component="h2" 
            gutterBottom 
            sx={{ 
              mt: 3, 
              mb: 1.5, 
              fontWeight: 700,
              fontSize: '18px',
              color: '#000000'
            }}
          >
            3. Eligibility
          </Typography>
          
          <Typography 
            variant="body1" 
            sx={{
              fontSize: '16px',
              color: '#000000',
              fontWeight: 400,
              marginBottom: 0,
              marginTop: 0
            }}
          >
            You represent that you are at least 18 years old and have the legal authority to enter into these Terms.
          </Typography>
          
          <Typography 
            variant="body1" 
            sx={{
              fontSize: '16px',
              color: '#000000',
              fontWeight: 400,
              marginBottom: 0,
              marginTop: 0
            }}
          >
            If you are using the App on behalf of a company, you confirm that you are authorized to bind that entity.
          </Typography>

          <Typography 
            variant="h6" 
            component="h2" 
            gutterBottom 
            sx={{ 
              mt: 3, 
              mb: 1.5, 
              fontWeight: 700,
              fontSize: '18px',
              color: '#000000'
            }}
          >
            4. Use of the App
          </Typography>
          
          <Typography 
            variant="body1" 
            sx={{
              fontSize: '16px',
              color: '#000000',
              fontWeight: 400,
              marginBottom: 0,
              marginTop: 0
            }}
          >
            You agree to use the App only for lawful purposes and in compliance with all applicable Canadian and United States laws.
          </Typography>
          
          <Typography 
            variant="body1" 
            sx={{
              fontSize: '16px',
              color: '#000000',
              fontWeight: 400,
              marginBottom: 0,
              marginTop: 0
            }}
          >
            You may not reverse engineer, decompile, or exploit the App, interfere with its security or performance, upload malicious code, or attempt unauthorized access to systems or data.
          </Typography>

          <Typography 
            variant="h6" 
            component="h2" 
            gutterBottom 
            sx={{ 
              mt: 3, 
              mb: 1.5, 
              fontWeight: 700,
              fontSize: '18px',
              color: '#000000'
            }}
          >
            5. Intellectual Property
          </Typography>
          
          <Typography 
            variant="body1" 
            sx={{
              fontSize: '16px',
              color: '#000000',
              fontWeight: 400,
              marginBottom: 0,
              marginTop: 0
            }}
          >
            All content, software, trademarks, logos, designs, and materials within the App are owned by Transpots Inc. or its licensors and are protected under Canadian and United States intellectual property laws.
          </Typography>
          
          <Typography 
            variant="body1" 
            sx={{
              fontSize: '16px',
              color: '#000000',
              fontWeight: 400,
              marginBottom: 0,
              marginTop: 0
            }}
          >
            You are granted a limited, non-exclusive, non-transferable, revocable license to use the App solely for its intended purpose. No ownership rights are transferred to you.
          </Typography>

          <Typography 
            variant="h6" 
            component="h2" 
            gutterBottom 
            sx={{ 
              mt: 3, 
              mb: 1.5, 
              fontWeight: 700,
              fontSize: '18px',
              color: '#000000'
            }}
          >
            6. Privacy and Data Protection
          </Typography>
          
          <Typography 
            variant="body1" 
            sx={{
              fontSize: '16px',
              color: '#000000',
              fontWeight: 400,
              marginBottom: 0,
              marginTop: 0
            }}
          >
            Your use of the App is subject to our Privacy Policy, which complies with Canada&apos;s Personal Information Protection and Electronic Documents Act (PIPEDA) and applicable United States privacy and consumer protection laws.
          </Typography>
          
          <Typography 
            variant="body1" 
            sx={{
              fontSize: '16px',
              color: '#000000',
              fontWeight: 400,
              marginBottom: 0,
              marginTop: 0
            }}
          >
            You consent to the collection, use, storage, and processing of your information in Canada, the United States, or other jurisdictions where our service providers operate.
          </Typography>

          <Typography 
            variant="h6" 
            component="h2" 
            gutterBottom 
            sx={{ 
              mt: 3, 
              mb: 1.5, 
              fontWeight: 700,
              fontSize: '18px',
              color: '#000000'
            }}
          >
            7. Messaging and A2P 10DLC Compliance
          </Typography>
          
          <Typography 
            variant="body1" 
            sx={{
              fontSize: '16px',
              color: '#000000',
              fontWeight: 400,
              marginBottom: 0,
              marginTop: 0
            }}
          >
            The App may include messaging or SMS features powered by third-party providers such as Twilio.
          </Typography>
          
          <Typography 
            variant="body1" 
            sx={{
              fontSize: '16px',
              color: '#000000',
              fontWeight: 400,
              marginBottom: 0,
              marginTop: 0
            }}
          >
            A2P 10DLC registration is available through the Regulatory Compliance portion of the Messaging section in the Twilio Console and must be completed by account Owners or Admins, where applicable.
          </Typography>
          
          <Typography 
            variant="body1" 
            sx={{
              fontSize: '16px',
              color: '#000000',
              fontWeight: 400,
              marginBottom: 0,
              marginTop: 0
            }}
          >
            You are responsible for ensuring that any messaging activity conducted through the App complies with applicable carrier rules, consent requirements, and messaging regulations.
          </Typography>
          
          <Typography 
            variant="body1" 
            sx={{
              fontSize: '16px',
              color: '#000000',
              fontWeight: 400,
              marginBottom: 0,
              marginTop: 0
            }}
          >
            Transpots Inc. is not responsible for messaging restrictions, delivery failures, or enforcement actions resulting from incomplete or non-compliant registration.
          </Typography>

          <Typography 
            variant="h6" 
            component="h2" 
            gutterBottom 
            sx={{ 
              mt: 3, 
              mb: 1.5, 
              fontWeight: 700,
              fontSize: '18px',
              color: '#000000'
            }}
          >
            8. Third-Party Services
          </Typography>
          
          <Typography 
            variant="body1" 
            sx={{
              fontSize: '16px',
              color: '#000000',
              fontWeight: 400,
              marginBottom: 0,
              marginTop: 0
            }}
          >
            The App may integrate with third-party services, platforms, or APIs.
          </Typography>
          
          <Typography 
            variant="body1" 
            sx={{
              fontSize: '16px',
              color: '#000000',
              fontWeight: 400,
              marginBottom: 0,
              marginTop: 0
            }}
          >
            Transpots Inc. does not control and is not responsible for third-party content, services, availability, or data practices.
          </Typography>
          
          <Typography 
            variant="body1" 
            sx={{
              fontSize: '16px',
              color: '#000000',
              fontWeight: 400,
              marginBottom: 0,
              marginTop: 0
            }}
          >
            Your use of third-party services is governed by their respective terms and policies.
          </Typography>

          <Typography 
            variant="h6" 
            component="h2" 
            gutterBottom 
            sx={{ 
              mt: 3, 
              mb: 1.5, 
              fontWeight: 700,
              fontSize: '18px',
              color: '#000000'
            }}
          >
            9. Indemnification
          </Typography>
          
          <Typography 
            variant="body1" 
            sx={{
              fontSize: '16px',
              color: '#000000',
              fontWeight: 400,
              marginBottom: 0,
              marginTop: 0
            }}
          >
            You agree to indemnify and hold harmless Transpots Inc., its directors, officers, employees, and agents from any claims, damages, losses, liabilities, or expenses arising from your use of the App, your violation of these Terms, or your violation of any applicable law or third-party rights.
          </Typography>

          <Typography 
            variant="h6" 
            component="h2" 
            gutterBottom 
            sx={{ 
              mt: 3, 
              mb: 1.5, 
              fontWeight: 700,
              fontSize: '18px',
              color: '#000000'
            }}
          >
            10. Disclaimer
          </Typography>
          
          <Typography 
            variant="body1" 
            sx={{
              fontSize: '16px',
              color: '#000000',
              fontWeight: 400,
              marginBottom: 0,
              marginTop: 0
            }}
          >
            The App is provided &quot;as is&quot; and &quot;as available,&quot; without warranties of any kind.
          </Typography>
          
          <Typography 
            variant="body1" 
            sx={{
              fontSize: '16px',
              color: '#000000',
              fontWeight: 400,
              marginBottom: 0,
              marginTop: 0
            }}
          >
            To the maximum extent permitted by law, Transpots Inc. disclaims all express and implied warranties, including merchantability, fitness for a particular purpose, non-infringement, and availability.
          </Typography>

          <Typography 
            variant="h6" 
            component="h2" 
            gutterBottom 
            sx={{ 
              mt: 3, 
              mb: 1.5, 
              fontWeight: 700,
              fontSize: '18px',
              color: '#000000'
            }}
          >
            11. Limitation of Liability
          </Typography>
          
          <Typography 
            variant="body1" 
            sx={{
              fontSize: '16px',
              color: '#000000',
              fontWeight: 400,
              marginBottom: 0,
              marginTop: 0
            }}
          >
            To the maximum extent permitted by law, Transpots Inc. shall not be liable for any indirect, incidental, consequential, special, or punitive damages, including loss of profits, data, goodwill, or business interruption.
          </Typography>
          
          <Typography 
            variant="body1" 
            sx={{
              fontSize: '16px',
              color: '#000000',
              fontWeight: 400,
              marginBottom: 0,
              marginTop: 0
            }}
          >
            In all cases, Transpots Inc.&apos;s total liability shall not exceed the amount paid by you to Transpots Inc. in the twelve months preceding the claim, or CAD $100 if no fees were paid.
          </Typography>
          
          <Typography 
            variant="body1" 
            sx={{
              fontSize: '16px',
              color: '#000000',
              fontWeight: 400,
              marginBottom: 0,
              marginTop: 0
            }}
          >
            Some jurisdictions do not allow certain limitations, so these limitations apply only to the extent permitted by law.
          </Typography>

          <Typography 
            variant="h6" 
            component="h2" 
            gutterBottom 
            sx={{ 
              mt: 3, 
              mb: 1.5, 
              fontWeight: 700,
              fontSize: '18px',
              color: '#000000'
            }}
          >
            12. Suspension and Termination
          </Typography>
          
          <Typography 
            variant="body1" 
            sx={{
              fontSize: '16px',
              color: '#000000',
              fontWeight: 400,
              marginBottom: 0,
              marginTop: 0
            }}
          >
            We may suspend or terminate your access to the App at any time, with or without notice, if you violate these Terms, if required by law, or if necessary to protect the platform, users, or the Company.
          </Typography>
          
          <Typography 
            variant="body1" 
            sx={{
              fontSize: '16px',
              color: '#000000',
              fontWeight: 400,
              marginBottom: 0,
              marginTop: 0
            }}
          >
            Upon termination, your right to use the App ends immediately.
          </Typography>

          <Typography 
            variant="h6" 
            component="h2" 
            gutterBottom 
            sx={{ 
              mt: 3, 
              mb: 1.5, 
              fontWeight: 700,
              fontSize: '18px',
              color: '#000000'
            }}
          >
            13. App Store and Play Store Compliance
          </Typography>
          
          <Typography 
            variant="body1" 
            sx={{
              fontSize: '16px',
              color: '#000000',
              fontWeight: 400,
              marginBottom: 0,
              marginTop: 0
            }}
          >
            You acknowledge and agree that these Terms are between you and Transpots Inc., not Apple or Google.
          </Typography>
          
          <Typography 
            variant="body1" 
            sx={{
              fontSize: '16px',
              color: '#000000',
              fontWeight: 400,
              marginBottom: 0,
              marginTop: 0
            }}
          >
            Apple Inc. and Google LLC are not responsible for the App, its content, maintenance, or support.
          </Typography>
          
          <Typography 
            variant="body1" 
            sx={{
              fontSize: '16px',
              color: '#000000',
              fontWeight: 400,
              marginBottom: 0,
              marginTop: 0
            }}
          >
            Any claims related to the App must be directed to Transpots Inc., not Apple or Google.
          </Typography>
          
          <Typography 
            variant="body1" 
            sx={{
              fontSize: '16px',
              color: '#000000',
              fontWeight: 400,
              marginBottom: 0,
              marginTop: 0
            }}
          >
            Your use of the App must also comply with applicable App Store and Google Play Store terms and policies.
          </Typography>

          <Typography 
            variant="h6" 
            component="h2" 
            gutterBottom 
            sx={{ 
              mt: 3, 
              mb: 1.5, 
              fontWeight: 700,
              fontSize: '18px',
              color: '#000000'
            }}
          >
            14. Governing Law and Jurisdiction
          </Typography>
          
          <Typography 
            variant="body1" 
            sx={{
              fontSize: '16px',
              color: '#000000',
              fontWeight: 400,
              marginBottom: 0,
              marginTop: 0
            }}
          >
            For Canadian users, these Terms are governed by the laws of the Province of Ontario and the federal laws of Canada.
          </Typography>
          
          <Typography 
            variant="body1" 
            sx={{
              fontSize: '16px',
              color: '#000000',
              fontWeight: 400,
              marginBottom: 0,
              marginTop: 0
            }}
          >
            For United States users, these Terms are governed by applicable U.S. federal law and the laws of the State of Delaware, excluding conflict of law rules.
          </Typography>

          <Typography 
            variant="h6" 
            component="h2" 
            gutterBottom 
            sx={{ 
              mt: 3, 
              mb: 1.5, 
              fontWeight: 700,
              fontSize: '18px',
              color: '#000000'
            }}
          >
            15. Dispute Resolution
          </Typography>
          
          <Typography 
            variant="body1" 
            sx={{
              fontSize: '16px',
              color: '#000000',
              fontWeight: 400,
              marginBottom: 0,
              marginTop: 0
            }}
          >
            Before initiating any legal action, you agree to attempt to resolve disputes informally by contacting Transpots Inc.
          </Typography>
          
          <Typography 
            variant="body1" 
            sx={{
              fontSize: '16px',
              color: '#000000',
              fontWeight: 400,
              marginBottom: 0,
              marginTop: 0
            }}
          >
            Nothing in this section limits statutory consumer rights under Canadian or United States law.
          </Typography>

          <Typography 
            variant="h6" 
            component="h2" 
            gutterBottom 
            sx={{ 
              mt: 3, 
              mb: 1.5, 
              fontWeight: 700,
              fontSize: '18px',
              color: '#000000'
            }}
          >
            16. Severability
          </Typography>
          
          <Typography 
            variant="body1" 
            sx={{
              fontSize: '16px',
              color: '#000000',
              fontWeight: 400,
              marginBottom: 0,
              marginTop: 0
            }}
          >
            If any provision of these Terms is found unenforceable, the remaining provisions shall remain in full force and effect.
          </Typography>

          <Typography 
            variant="h6" 
            component="h2" 
            gutterBottom 
            sx={{ 
              mt: 3, 
              mb: 1.5, 
              fontWeight: 700,
              fontSize: '18px',
              color: '#000000'
            }}
          >
            17. Contact Information
          </Typography>
          
          <Typography 
            variant="body1" 
            sx={{
              fontSize: '16px',
              color: '#000000',
              fontWeight: 400,
              marginBottom: 0,
              marginTop: 0
            }}
          >
            <strong>Transpots Inc.</strong>
          </Typography>
          
          <Typography 
            variant="body1" 
            sx={{
              fontSize: '16px',
              color: '#000000',
              fontWeight: 400,
              marginBottom: 0,
              marginTop: 0
            }}
          >
            Email: info@transpots.com
          </Typography>
          
          <Typography 
            variant="body1" 
            sx={{
              fontSize: '16px',
              color: '#000000',
              fontWeight: 400,
              marginBottom: 0,
              marginTop: 0
            }}
          >
            Website:{' '}
            <a 
              href="https://transpots.com" 
              target="_blank" 
              rel="noopener noreferrer"
              style={{ 
                color: '#0075ff', 
                textDecoration: 'none' 
              }}
            >
              https://transpots.com
            </a>
          </Typography>
          </Box>
        </Paper>
      </Container>
    </Box>
  )
}

export default PrivacyPage

